import { render, staticRenderFns } from "./BuildYourCompany.vue?vue&type=template&id=40caf7b6"
import script from "./BuildYourCompany.vue?vue&type=script&lang=js"
export * from "./BuildYourCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/TypXw3yGP/0/DHCCorporation/dhc-cloud-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40caf7b6')) {
      api.createRecord('40caf7b6', component.options)
    } else {
      api.reload('40caf7b6', component.options)
    }
    module.hot.accept("./BuildYourCompany.vue?vue&type=template&id=40caf7b6", function () {
      api.rerender('40caf7b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BuildYourCompany.vue"
export default component.exports